import 'reflect-metadata'
import { define, auto, type, Store } from 'type-r';
import moment from 'moment'
import Subscription from './subscription'
import MenuItem, { MenuItemCollection } from './menu_item'

@define
export default class SiteStore extends Store {
    @type(MenuItem).as menu : MenuItem;
    @type(Number).as productId : number
    @auto productIds: number[]
    @type(MenuItemCollection).as menus: MenuItemCollection
    
    @type(Subscription).as subscription: Subscription

    @auto dt : Date
    @auto startSection: number
    @auto currentSection: number
    @auto btnNextSel: string
    @auto btnPrevSel: string
    @auto(true) firstFound: boolean
    @auto mealFields: {[key:string]: any}
    @auto currentDate: string
    @auto(false) mealDone: boolean
    
    initialize() {
        this.currentDate = moment().format('MM/DD/YYYY');
        
        this.menu = new MenuItem({});
        this.subscription = new Subscription();
    }

    meal_section(name:string) {
	for (var x = 0;x < this.mealFields.length;x++) {
	    if (this.mealFields[x].section == name)
		return x;
	}
	return -1;
    }
    
    meal_id(name:string) {
	for(var sect in this.mealFields) {
	    for (var fld in this.mealFields[sect].fields) {
		if (fld != name) continue;
		return this.mealFields[sect].fields[fld].id;
	    }
	}
	return null;	
    }
    
    meal_get(name:string) {
	for(var sect in this.mealFields) {
	    for (var fld in this.mealFields[sect].fields) {
		if (fld != name) continue;
		return $('[data-id="' + this.mealFields[sect].fields[fld].id + '"]');
	    }
	}
	return null;
    }
}

export var currentStore = new SiteStore();

